export const getNativeLanguageName = (code: string, t: (key: string) => string) => {
    try {
        const displayNames = new Intl.DisplayNames([code], { type: 'language' });
        const nativeName = displayNames.of(code);

        if (!nativeName) {
            return t(`languagePicker.languages.${code}`);
        }

        return nativeName;
    } catch {
        return t(`languagePicker.languages.${code}`);
    }
};
